import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';

$(document).ready(function() {
  $('.related-color-products .related-value-wrapper').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    rows: 0,
    responsive: [
      {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
          }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 8,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 4,
        }
      }
    ]
  });

  setTimeout(function() {
    $('.related-color-products .related-value-wrapper').css('opacity', '1');
  }, 1500);

  //slick slider
  var _slick = false;
  var _is_sliding = false;

  if (!_slick && $('.product-single__images-group').find('.product-single__images--wrapper').length > 1) {

    var carousel = $('.product-single__images-group').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      slide: '.product-single__images--wrapper',
      arrows: true,
      dots: true,
      rows: 0
    });
    _slick = true;

    carousel.on('beforeChange', function() {
      _is_sliding = true;
    });

    carousel.on('afterChange', function() {
      _is_sliding = false;
    });

  } else if (_slick) {
    $('.product-single__images-group').slick('unslick');
    _slick = false;

  }

  setTimeout(function() {
    $('.product-single__images-group').css('opacity', '1');
  }, 1500);

  var pswpElement = document.querySelectorAll('.pswp')[0];

  var gallery;
  var items = [];
  var images = $('.product-single__images--wrapper .zoom__img');

  if(!images.length) {
      return;
  }

  images.each(function() {
    var img = $(this);
    var aspectRatio = parseFloat(img.attr('data-aspectratio'));
    var zoomImg = img.attr('data-zoom-src');
    items.push({
      src: zoomImg,
      w: 2000 * aspectRatio,
      h: 2000
    });

    img.on('click', function(e) {
      if (_is_sliding) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }

      if (window.PREVENT_ZOOM) return;
      var index = images.index(this);

      var options = {
        index: index,
        zoomEl: true,
        shareEl: false,
        fullscreenEl: false,
        arrowKeys: false,
        counterEl: false,
        showHideOpacity: true,
        closeOnScroll: false,
        closeOnVerticalDrag: false,
        pinchToClose: false,
        focus: false,
      };

      gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
      gallery.init();
      //gallery.zoomTo(1, {x:gallery.viewportSize.x/2,y:gallery.viewportSize.y/2});
    });
  });

  $(".engrave-container input").on('input', function() {
    var engrave_image = $('.engrave-image .product-single__images--wrapper');
    var slider = $('.product-single__images-group');
    var select = $('.product-form__item .single-option-selector__radio');

    if(engrave_image) {
      if($(this).val().length > 0) {
        slider.slick('slickAdd', engrave_image);
        var lastIndex = $('.product-single__images-group .product-single__images--wrapper').length;
        slider.slick('slickGoTo', lastIndex - 1, true);
        select.val('Custom').trigger('change');

        var engrave_string = $(this).val();
        var incorrect_char = false;
        var consent_char = "abcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()-=[];',./_+{}:<>?\"| ";
        var new_consent_char = "àèìòùáéíóúýâêîôûãñõäëïöüÿåæœçðøß";
        consent_char += new_consent_char;
        var i= 0;
        var not_allowed = "";
        var new_engrave_string = ""

        while (i < engrave_string.length) {
          var char = engrave_string[i];
          if(consent_char.indexOf(char.toLowerCase()) === -1){
            new_engrave_string = engrave_string.replace(char, '');
            engrave_string = new_engrave_string;
            incorrect_char = true;
            not_allowed = not_allowed + char;
          } else {
            i++;
            new_engrave_string = engrave_string;
          }
        }

        new_engrave_string = new_engrave_string.substring(0,10)
        let $engraveText = $('.engrave-text')

        $engraveText.text(new_engrave_string);
        $('.engrave-container input').val(new_engrave_string);
        if($(this).val() == "") {
          select.val('Classic').trigger('change');
        }
        if(!incorrect_char) {
          $engraveText.text(engrave_string);
        } else {
          $('.engrave-not-allow span').html(not_allowed);
          $('.engrave-not-allow').removeClass('hidden');

          setTimeout(function() {
            $('.engrave-not-allow').addClass('hidden');
          }, 2000)
        }
        
      } else {
        $('.slick-slide.engrave-image-wrapper:not(.slick-cloned)').appendTo('.engrave-image');
        $('.slick-track .slick-slide.engrave-image-wrapper').remove();
        slider.slick('slickRemove');
        slider.slick('slickGoTo', 0, true);
        select.val('Classic').trigger('change');
      }
    }
  });
});
